<template>
  <div class="base-info-detail">
    <slot></slot>
  </div>
</template>

<script setup>
/**
 * The stuff inside the dark blue block.
 */
defineOptions({
  name: 'BaseInfoDetail'
})
</script>

<style lang="scss" scoped>
.base-info-detail {
  @extend %info-detail;
}
</style>